module.exports = __webpack_public_path__ + "img/goal-11.dee60c64.png";